import * as React from 'react';
import {useDispatch} from 'react-redux';

import {refreshProfileGeoLocationAction} from '~/modules/App/store/geoActions';
import {MODAL_ALLOW_LOCATION} from '~/rootStore/modals/modalsIds';
import useModalById from '~/customHooks/useModalById';
import {logEvent} from '~/modules/App/store/gaActions';
import localStorageWrapper from '~/utils/localStorageWrapper';

import ModalBaseContent from '../ModalBaseContent';
import ModalBase from '../ModalBase';
import image from './img/allow-location-icon.svg';

const ModalAllowLocation: React.FC = () => {
  const {
    isOpen,
    props: {profileId, callback},
    close: closeAllowLocationModal,
  } = useModalById(MODAL_ALLOW_LOCATION);
  const dispatch = useDispatch();

  const handleActionClick = async () => {
    if (callback && typeof callback === 'function') {
      callback();
    } else {
      await dispatch(refreshProfileGeoLocationAction(profileId));
    }
    closeAllowLocationModal();
    localStorageWrapper.setItem(MODAL_ALLOW_LOCATION, 'true');
    logEvent({
      category: 'location-modal',
      action: 'show-modal',
    });
  };

  return (
    <ModalBase open={isOpen} onClose={closeAllowLocationModal}>
      <ModalBaseContent
        p={2}
        image={image}
        title="Allow location access"
        description="To get access to chat and extra features you have to accept location requests made by application."
        actionButtonText="OK"
        onClickActionButton={handleActionClick}
      />
    </ModalBase>
  );
};

export default ModalAllowLocation;
